import * as yup from 'yup';

export type AddressLookupStatus =
  | 'cmra'
  | 'verified'
  | 'partial_missing_secondary'
  | 'partial_unverified_secondary'
  | 'not_verified'
  | 'po_box'
  | 'suggested';

export type Address = {
  streetAddress: string;
  streetAddress2?: string;
  city: string;
  state: string;
  zip: string;
};

export type AddressLookupResponse = {
  status: AddressLookupStatus;
  address?: Address;
};

export type AutocompleteResponse = {
  suggestions: SmartyAddress[];
};

export type AutocompletePayload = {
  search: string;
  selected?: string;
};

export type SmartyAddress = {
  street_line: string;
  secondary: string;
  city: string;
  state: string;
  zipcode: string;
  entries: number;
};

export const INITIAL_ADDRESS: Address = {
  streetAddress: '',
  streetAddress2: '',
  city: '',
  state: '',
  zip: '',
};

export type OptionalAddress = Partial<Address>;

const requiredAddressSchema: { [key in keyof Address]: yup.AnySchema } = {
  streetAddress: yup.string().required('Street address is required'),
  city: yup.string().required('City is required'),
  state: yup.string().required('State is required'),
  zip: yup
    .string()
    .required('Zip code is required')
    .matches(/^\d{5}$/, 'Must be 5 digits'),
};

export { requiredAddressSchema };
